import { render, staticRenderFns } from "./ShowClinicalQuestionnaire.vue?vue&type=template&id=6089a76f"
import script from "./ShowClinicalQuestionnaire.vue?vue&type=script&lang=js"
export * from "./ShowClinicalQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./ShowClinicalQuestionnaire.vue?vue&type=style&index=0&id=6089a76f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports